<!-- Main Settings Page: Add more settings sections here as needed. Currently only TTS settings. -->
<template>
  <div class="relative flex flex-col justify-center items-center bg-gray-50 min-h-screen">
    <!-- Back Home Button -->
    <a href="/"
      class="top-6 left-6 z-10 absolute flex items-center bg-white hover:bg-gray-100 shadow px-4 py-2 border-2 border-black rounded-lg font-bold text-gray-700 transition">
      <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"
        stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M15 19l-7-7 7-7" />
      </svg>
      Home
    </a>
    <!-- End Back Home Button -->
    <div class="bg-white shadow-lg mt-12 p-8 rounded-lg settings-page">
      <h1 class="mb-4 font-bold text-gray-900 text-2xl">Settings</h1>
      <TTSSettings />
    </div>
  </div>
</template>

<script setup lang="ts">
import TTSSettings from '@/components/ui/TTSSettings.vue'
</script>

<style scoped>
.settings-page {
  max-width: 600px;
  width: 100%;
}
</style>